// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__UtYks","rootNoMargin":"styles_rootNoMargin__2lBDu"};